import safeMultiply from 'lumen/utils/numeric/safe-multiply';

// The value types this util understands. Relative values are stored as fractions
// (0.1) but shown/edited as percentages (10); absolute values are shown as-is.
const VALUE_TYPE = {
  ABSOLUTE: 'absolute',
  RELATIVE: 'relative',
} as const;

type ValueType = (typeof VALUE_TYPE)[keyof typeof VALUE_TYPE];

// BE stored value -> FE display value.
export function toDisplayValue(value: number, type: ValueType): number {
  if (type !== VALUE_TYPE.RELATIVE) {
    return value;
  }

  return safeMultiply(value, 100) ?? value;
}

// FE display value -> BE stored value. Inverse of toDisplayValue.
export function toStoredValue(value: number, type: ValueType): number {
  if (type !== VALUE_TYPE.RELATIVE) {
    return value;
  }

  return safeMultiply(value, 1 / 100) ?? value;
}
